import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import { api } from "@/lib/api";

const FOOTER_LEGAL = [
  ["disclaimer", "Disclaimer"],
  ["terms", "Terms"],
  ["privacy", "Privacy"],
  ["cookies", "Cookies"],
  ["accessibility", "Accessibility"],
  ["ai-transparency", "AI Transparency"],
  ["acceptable-use", "Acceptable Use"],
];
const ALIAS = { aup: "acceptable-use" };

export default function Legal() {
  const { slug: p } = useParams();
  const loc = useLocation();
  const nav = useNavigate();
  const raw = p || loc.pathname.replace(/^\//, "") || "disclaimer";
  const slug = ALIAS[raw] || raw;
  const [page, setPage] = useState(null);

  useEffect(() => {
    setPage(null);
    api.get(`/legal/${slug}`).then(r => setPage(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div className="k-canvas" style={{ minHeight: "100vh" }}>
      <PublicNav />
      <div style={{ margin: "0 auto", padding: "56px 24px 24px" }}>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 28 }}>
          {FOOTER_LEGAL.map(([s, label]) => (
            <a key={s} className={`k-badge ${s === slug ? "k-badge-accent" : ""}`} onClick={() => nav(`/${s}`)}
              data-testid={`legal-tab-${s}`} style={{ textDecoration: "none", cursor: "pointer" }}>{label}</a>
          ))}
        </div>

        {page && page.error && (
          <p className="k-muted" data-testid="legal-not-found">This document could not be found.</p>
        )}

        {page && !page.error && (
          <div className="k-fadein" data-testid="legal-body">
            <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginBottom: 18 }}>
              <span className="k-badge k-badge-sandbox" data-testid="legal-draft-label">{page.label}</span>
              <span className="k-muted" style={{ fontSize: 13 }} data-testid="legal-review-status">
                Review status: {page.review_status}
              </span>
            </div>

            <h1 className="k-heading" data-testid="legal-title"
              style={{ fontSize: "clamp(36px,5vw,56px)", letterSpacing: "-.03em", margin: 0 }}>
              {page.title || slug}
            </h1>

            {page.meta && (
              <div style={{ marginTop: 20, borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)", padding: "16px 0", display: "flex", flexDirection: "column", gap: 6 }}>
                {page.meta.map(([k, v]) => (
                  <div key={k} style={{ fontSize: 13.5 }}>
                    <span className="k-muted">{k}: </span>
                    <span className="k-heading" style={{ fontWeight: 500 }}>{v}</span>
                  </div>
                ))}
              </div>
            )}

            {page.sections && page.sections.map(([h, body]) => (
              <section key={h} style={{ marginTop: 30 }}>
                <h2 className="k-heading" style={{ fontSize: 19, letterSpacing: "-.01em", marginBottom: 10, fontWeight: 700 }}>{h}</h2>
                <p className="k-muted" style={{ fontSize: 15, lineHeight: 1.7, whiteSpace: "pre-line", margin: 0 }}>{body}</p>
              </section>
            ))}

            {!page.sections && page.body && (
              <p className="k-muted" style={{ fontSize: 15, lineHeight: 1.7, whiteSpace: "pre-line", marginTop: 24 }}>{page.body}</p>
            )}
          </div>
        )}
      </div>
      <PublicFooter />
    </div>
  );
}
